import { z } from 'zod';

import { zodParsingCaseStatusSchema } from '../useQueryParsingCases/validations';

/**
 * @see https://app.dev.vestigas.com/redoc#tag/Parsing-Cases/operation/post_restore_parsing_case_delivery_note_parsing_cases__case_id__actions_restore_post
 */
export const zodRestoreParsingCaseResponseSchema = z.object({
  caseId: z.uuid(),
  jobId: z.uuid(),
  parsedJsonSasUrl: z.string().nullish(),
  status: zodParsingCaseStatusSchema,
});
